var FINANCIAL_MENU_COMPONENT = '/financial';
var FINANCIAL_COMMISSION_COMPONENT = '/financial/commission';
var FINANCIAL_STORE_COMPONENT = '/financial/storeFinance';
function ensureMenu(children, menuConfig) {
  var existingMenu = children.find(function (item) {
    return item.component === menuConfig.component;
  });
  if (existingMenu) {
    existingMenu.childList = existingMenu.childList || [];
    if (menuConfig.childList && menuConfig.childList.length) {
      menuConfig.childList.forEach(function (child) {
        return ensureMenu(existingMenu.childList, child);
      });
    }
    return existingMenu;
  }
  children.push(menuConfig);
  return menuConfig;
}
export function injectFinancialMenus(menuList) {
  var menus = Array.isArray(menuList) ? menuList : [];
  var financialMenu = menus.find(function (item) {
    return item.component === FINANCIAL_MENU_COMPONENT;
  });
  if (!financialMenu) {
    return menus;
  }
  financialMenu.childList = financialMenu.childList || [];
  var commissionMenu = financialMenu.childList.find(function (item) {
    return item.component === FINANCIAL_COMMISSION_COMPONENT;
  });
  if (commissionMenu) {
    commissionMenu.childList = commissionMenu.childList || [];
    ensureMenu(commissionMenu.childList, {
      id: -9101,
      pid: commissionMenu.id,
      name: '财务设置',
      icon: '',
      perms: 'admin:finance:apply:update',
      component: '/financial/commission/setting',
      menuType: 'C',
      childList: []
    });
  }
  ensureMenu(financialMenu.childList, {
    id: -9200,
    pid: financialMenu.id,
    name: '门店财务',
    icon: '',
    perms: 'admin:finance:monitor:list',
    component: FINANCIAL_STORE_COMPONENT,
    menuType: 'M',
    childList: [{
      id: -9201,
      pid: -9200,
      name: '门店流水',
      icon: '',
      perms: 'admin:finance:monitor:list',
      component: '/financial/storeFinance/flow',
      menuType: 'C',
      childList: []
    }, {
      id: -9202,
      pid: -9200,
      name: '账单记录',
      icon: '',
      perms: 'admin:finance:monitor:list',
      component: '/financial/storeFinance/bill',
      menuType: 'C',
      childList: []
    }]
  });
  return menus;
}